export const API_ENDPOINTS = {
  auth: {
    login: '/api/v1/Auth/login',
    google: '/api/v1/Auth/google',
    register: '/api/v1/users',
    activate: '/api/v1/Auth/activate',
    completeGoogleSignup: '/api/v1/Auth/complete-google-signup',
    forgotPassword: '/api/v1/Auth/forgot-password',
    resetPassword: '/api/v1/Auth/reset-password',
  },
  public: {
    sites: '/api/v1/public/sites',
    agendas: '/api/v1/public/agendas', // Legacy, kept for backward compatibility
    bookings: '/api/v1/public/bookings', // Legacy
    events: '/api/v1/public/events',
  },
  bookingRequests: '/api/v1/booking-requests',
  businesses: {
    business: '/api/v1/businesses',
    clients: '/api/v1/businesses/clients',
    services: '/api/v1/businesses/services',
    types: '/api/v1/business-types',
    professionalCount: '/api/v1/businesses/professional-count',
  },
  country: '/api/v1/users/countries',
  membership: '/api/v1/api/membership',
};
